import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "kiwi-widget-container",
    class: _defineProperty({
      'kiwi-widget-container--minimized': _vm.minimized,
      'kiwi-widget-container--expanded': !_vm.minimized
    }, "kiwi-widget-container--position-".concat(_vm.position), true)
  }, [_vm.minimized ? _c('div', {
    staticClass: "kiwi-widget-minimized",
    on: {
      "click": _vm.toggleMinimized
    }
  }, [_c('div', {
    staticClass: "kiwi-widget-minimized-header"
  }, [_c('div', {
    staticClass: "kiwi-widget-minimized-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._m(0)])]) : _c('div', {
    staticClass: "kiwi-widget-expanded"
  }, [_c('div', {
    staticClass: "kiwi-widget-expanded-header"
  }, [_c('div', {
    staticClass: "kiwi-widget-expanded-title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "kiwi-widget-expanded-controls"
  }, [_c('button', {
    staticClass: "kiwi-widget-expanded-minimize",
    on: {
      "click": _vm.toggleMinimized
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])])]), _c('div', {
    staticClass: "kiwi-widget-expanded-content"
  }, [_vm._t("default")], 2)])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "kiwi-widget-minimized-icon"
  }, [_c('i', {
    staticClass: "fa fa-comments"
  })]);
}];
export { render, staticRenderFns };